import React, {useCallback} from "react";
import {PaginationContainer} from "./table-pagination.styles.js";
function TablePagination({
  onLimitChange,
  onPaginationChange,
  pagination = 1,
  total,
  limit,
  tableLimits = [3, 5, 10]
}) {
  const handlePageChange = useCallback((newPage) => {
    if (onPaginationChange) {
      onPaginationChange(newPage + 1);
    }
  }, [onPaginationChange]);
  const handleLimitChange = useCallback((e) => {
    if (onLimitChange) {
      onLimitChange(parseInt(e.target.value, 10));
    }
  }, [onLimitChange]);
  return /* @__PURE__ */ React.createElement(PaginationContainer, {
    component: "div",
    count: total || 0,
    labelDisplayedRows: (rows) => `${rows.from}-${rows.to} of ${rows.count}`,
    onPageChange: (event, newPage) => handlePageChange(newPage),
    onRowsPerPageChange: handleLimitChange,
    page: total > 0 ? pagination - 1 : 0,
    rowsPerPage: limit,
    rowsPerPageOptions: tableLimits,
    SelectProps: {
      native: true
    }
  });
}
export default /* @__PURE__ */ React.memo(TablePagination);
